export default "__VITE_ASSET__CsYAg0eQ__"